<div class="table-area">
    <perfect-scrollbar class="table-area"  [config]="scrollConfig">
        <table class="table table-hover">
            <thead class="thead-light">
            <tr>
                <th class="sorting"
                    [class.acs]="sortColumn === col && sortAsc"
                    [class.dcs]="sortColumn === col && !sortAsc"
                    [class.text-right]="col.textRight"
                    *ngFor="let col of columns"
                    (click)="sortBy(col)">
                    {{col.title}}
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let site of pageSites">
                <td>{{site.code}}</td>
                <td>
                    <a [routerLink]="['/admin','plantingSites', site.id]" title="Edit">{{site.title}}</a>
                </td>
                <td>{{site.country}}</td>
                <td>{{site.region}}</td>
                <td class="text-right">{{site.plantingDate | date: 'yyyy'}}</td>
                <td class="text-right">{{site.photoCollectionCount}}</td>
                <td class="text-right">{{site.totalTrees | number}}</td>
                <td class="text-right">{{site.availableTrees | number}}</td>
                <td class="table-button">
                    <popover-component [data]="site.missingData[site.id]"></popover-component>
                    <a *ngIf="currentUser?.permissions.canManagePlantingSites" class="edit" [routerLink]="['/admin','plantingSites', site.id]" title="Edit"><i class="icon-note"></i></a>
                    <a *ngIf="currentUser?.permissions.canManageUsers" class="delete" (click)="showDeleteConfirmModal(site)" title="Delete"><i class="icon-trash"></i></a>
                </td>
            </tr>
            </tbody>
        </table>
    </perfect-scrollbar>
    <div class="no-data" *ngIf="pageSites.length == 0">
        <h2><i class="icon-layers"></i></h2>
        <h3>The list is empty.</h3>
    </div>
</div>
    <pagination  [itemsPerPage]="pageSize" [style.display]="pageSites.length > 0 ? 'block' : 'none'"
            [totalItems]="_sites.length"
            (pageChanged)="pageChange($event.page)"></pagination>

<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>
